import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old Contractors list, kept only as a redirect.
 *
 * Contractors is a tab on Maintenance now rather than a rail slot of its own — the reasoning is in
 * `MaintenanceNav`. The old address was the only way in for long enough to be bookmarked, so it
 * forwards rather than falling through to a not-found page, search and all: a saved workspace link
 * is `?workspace=…` on the end of it. `replace` so Back does not bounce off it.
 */
export const Route = createFileRoute('/contractors/')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/maintenance/contractors', search, replace: true });
  },
});
